import React, { useState } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import Card from '../../../components/Card'
import { useCreateForwarderMutation } from '../../../api/forwardersAPISlices'
import { useNavigate } from 'react-router-dom'
import Toaster from '../../../components/utility/Toaster'

const ForwardersAdd = () => {
    const [forwardingUrl, setForwardingUrl] = useState('');
    const [token, setToken] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const [showToster, setShowToster] = useState(false);
    const [tosterMassage, setTosterMassage] = useState('');
    const [tosterStatus, setTosterStatus] = useState('');
    const [errors, setErrors] = useState({});

    const navigate = useNavigate();

    const [createForwarder] = useCreateForwarderMutation();

    const onSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true)

        const payload = {
            forwarding_url: forwardingUrl,
        };

        // Only add token if provided
        if (token && token.trim()) {
            payload.token = token.trim();
        }

        const authToken = JSON.parse(localStorage.getItem("token"));

        await createForwarder({ payload, token: authToken })
            .unwrap()
            .then((res) => {
                setErrors({})
                navigate("/forwarders-list");
                setIsLoading(false)
            })
            .catch((error) => {
                setShowToster(true)
                setTosterMassage(error?.data?.message || 'Error creating forwarder')
                setTosterStatus('error')
                setErrors(error?.data?.errors || {})

                setIsLoading(false)
            });
    };

    return (
        <>
            <Container fluid>
                <Row>
                    <Col lg="12" className='mb-5'>
                        <Card>
                            <Card.Header>
                                <Card.Header.Title>
                                    <h4 className="card-title">Add Lead Forwarder</h4>
                                </Card.Header.Title>
                            </Card.Header>

                            <Card.Body>
                                <Form onSubmit={onSubmit}>
                                    <Row>
                                        <Form.Group controlId="forwarding_url" as={Col} sm="12" md="8">
                                            <Form.Label>Forwarding URL:</Form.Label>
                                            <Form.Control
                                                type="url"
                                                placeholder="https://example.com/webhook"
                                                required
                                                value={forwardingUrl}
                                                onChange={(e) => setForwardingUrl(e.target.value)}
                                                isInvalid={errors?.forwarding_url && errors?.forwarding_url?.length > 0}
                                            />
                                            <Form.Text className="text-muted">
                                                Enter the URL where leads will be forwarded.
                                            </Form.Text>
                                            <Form.Control.Feedback type="invalid">
                                                {errors?.forwarding_url?.[0]}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group controlId="token" as={Col} sm="12" md="8" className="mt-3">
                                            <Form.Label>Custom Token (Optional):</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Leave empty to auto-generate"
                                                value={token}
                                                onChange={(e) => setToken(e.target.value)}
                                                isInvalid={errors?.token && errors?.token?.length > 0}
                                            />
                                            <Form.Text className="text-muted">
                                                Optionally provide a custom token. If left empty, a random token will be generated automatically.
                                            </Form.Text>
                                            <Form.Control.Feedback type="invalid">
                                                {errors?.token?.[0]}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Row>

                                    <div className="mt-4">
                                        <Button type="submit" variant="primary" disabled={isLoading}>
                                            <div
                                                style={{
                                                    transform: !isLoading ? 'translateX(-1.2rem)' : 'translateX(0)'
                                                }}
                                            >
                                                <div className="spinner-border text-warning loadding-spinner mr-2"
                                                    style={{
                                                        opacity: isLoading ? 100 : 0,
                                                    }}
                                                    role="status"
                                                >
                                                    <span className="visually-hidden"></span>
                                                </div>

                                                <span>Submit</span>
                                            </div>
                                        </Button>
                                        <Button
                                            variant="secondary"
                                            className="ml-2"
                                            onClick={() => navigate("/forwarders-list")}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <Toaster status={tosterStatus} message={tosterMassage} show={showToster} setShow={setShowToster} />
        </>
    )
}

export default ForwardersAdd
